export const API_URL = 'https://prod.malllogisticsapi.com/api/';
export const HANDSFREE_URL = 'https://handsfreeapi.com/';
